import { toast } from "react-toastify";
import { _TransportGuide, _TransportGuideInfo, _TransportGuideItem } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { EditorTransportRoute } from "../TransportRoute/EditorTransportRoute"
import { useEffect, useState } from "react";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { GoodsStateEditor } from "../GoodsState/GoodsStateEditor";
import { GoodsSupportEditor } from "../GoodsSupport/GoodsSupportEditor";
import { GoodsTypeEditor } from "../GoodsType/GoodsTypeEditor";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { TransportGuideItemNew } from "../TransportGuide/TransportGuideItemNew";
import useModal, { MODAL_LG, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import usePaginator from "../../../theme/Component/usePaginator";

export const PriceTransportGuide = () => {

    const { instance, setBean, bean } = useDataBean(_TransportGuide);
    const { instance: instanceItem, bean: beanItem, setBean: setBeanItem, lista: listaItem, setLista: setListaItem } = useDataBean(_TransportGuideItem);
    const { instance: instanceInfo, bean: beanInfo, setBean: setBeanInfo } = useDataBean(_TransportGuideInfo);

    const paginador = usePaginator();


    const [itemsguide, setitemsguide] = useState<any[]>([]);


    const modal = useModal("Agregar Piezas", MODAL_LG);
    const modalEdit = useModal("Editar Pieza", MODAL_LG);
    const modalC = useModal("Eliminar Pieza", MODAL_SM);

    useEffect(() => {
        // IDOffice: defaultOffice.IDOffice,
        // TransportGuideDocType: 25,
        // InvoiceToType: 26,
        // InvoiceFreightType: 20,
        setBean({
            TransportGuideDate: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
        });
    }, [])

    useEffect(() => {
        if (bean.IDTransportRoute) {
            editaItem(bean)
        }
    }, [bean.IDTransportRoute])

    useEffect(() => {
        if (listaItem.length > 0) {
            getTransportGuideItemValues()
        }
    }, [listaItem.length])


    const editaItem = (obj: any) => {
        console.log("Objeto editado ==============>", obj)
        instance.updateTransportGuide(obj).then(
            (resp: any) => {
                console.log(resp)
                setBean(resp)
            }
        ).catch(err => {
            toast.error(err);
        })
    }


    const head = [
        { title: 'ID', property: 'IDTransportGuideItem', visible: true },
        { title: 'Código Barras', property: 'TicketCode', visible: true },
        { title: 'Estado de Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Tipo de Carga', property: 'GoodsTypeName', visible: true },
        { title: 'Peso (Kg)', property: 'WeightKg', visible: true },
        { title: 'P/Real (Kg)', property: 'WeightKgReal', visible: true },
        { title: 'Largo (cm)', property: 'LongLength', visible: true },
        { title: 'Ancho (cm)', property: 'WidthLength', visible: true },
        { title: 'Alto (cm)', property: 'HightLength', visible: true },
        { title: 'Volumen', property: 'Volume', visible: true },
        { title: 'Descripción Pieza', property: 'Description', visible: true },
        { title: 'Total Liquidación', property: 'TotalAmount', visible: true, mask: MASK_MONEY },
        { title: 'Descuento', property: 'DiscountAmount', visible: true, mask: MASK_MONEY },
        { title: 'Valor Seguro', property: 'PolicyValue', visible: true, mask: MASK_MONEY },
        { title: 'Otros Valores', property: 'OthersValue', visible: true, mask: MASK_MONEY },
        { title: 'Errores de Liquidación', property: 'ErrorMessage', visible: true },
        { title: 'Liquidado', property: 'Liquidated', visible: true },
        { title: 'Tipo de Liquidación', property: 'LiquidateTypeName', visible: true },
        { title: 'Tipo Facturación', property: 'InvoiceFreightTypeName', visible: true },
        { title: 'Tipo de Carga', property: 'FreightTypeName', visible: true },
        { title: 'Kg Liquidados', property: 'LiquidatedKg', visible: true },
        { title: 'Valor Carga Liquidado', property: 'LiquidatedValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Básico', property: 'LiquidatedBasic', visible: true, mask: MASK_MONEY },
        { title: 'Tarifa (Kg)', property: 'RateValue', visible: true },
        { title: 'ID Producto', property: 'IDProduct', visible: true },
        { title: 'ID Producto Poliza', property: 'IDProductPolicy', visible: true },
    ]

    const create = () => {
        modal.open();
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getTransportGuideItemValues = () => {
        instanceInfo.getTransportGuideItemValues(bean.IDTransportGuide, bean.TransportGuideDate).then(
            (resp) => {
                setBeanInfo(resp)
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const getLista = () => {
        instanceItem.getTransportGuideItemCatalog(bean.IDTransportGuide, bean.TransportGuideDate, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                setListaItem(resp.List)
            }
        ).catch(err => { toast.error(err) })
    }

    const deleteTransportGuideItem = () => {

        instanceItem.deleteTransportGuideItem(bean.TransportGuideDate, beanItem.IDTransportGuideItem).then(
            (resp: any) => {
                if (resp) {
                    getLista();
                    modalC.close();
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const addTransportGuideItemList = () => {
        instanceItem.addTransportGuideItemList(bean.IDTransportGuide, bean.TransportGuideDate, itemsguide, _single.getAccountID()).then(
            (resp) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    return (
        <BasicPage titulo="Cotizacion de Guias de Transporte">
            <div className="row">
                <div className="col-md-12">
                    <EditorTransportRoute idSelector={bean.IDTransportRoute} onChange={(e) => { setBean({ ...bean, IDTransportRoute: e }) }} label="Ruta de Transporte" />
                </div>
                {bean.IDTransportGuide &&
                    <div className="row">
                        <div className="col-md-12">
                            <label>Detalle de Piezas</label>
                        </div>

                        <BasicTable body={listaItem} head={head} listButtons={listaBotones()} iconButtons={iconButtonsItem} rowSet={setBeanItem} records={paginador} />

                        <div className="col-12">
                            <label>Valores de Liquidación</label>
                            <table className="table table-bordered table-sm">
                                <thead className="table-light">
                                    <tr>
                                        {/* <th>Peso Real (Kg)</th> */}
                                        <th>Peso (Kg)</th>
                                        <th>Flete</th>
                                        <th>Seguro</th>
                                        <th>Otros</th>
                                        <th>Descuento</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.keys(beanInfo).length > 0 ? (
                                        <tr>
                                            {/* <td>{item.WeightKgReal ?? "-"}</td> */}
                                            <td>{beanInfo.WeightKg ?? "-"}</td>
                                            <td>{beanInfo.TotalAmount?.toLocaleString() ?? "-"}</td>
                                            <td>{beanInfo.PolicyValue?.toLocaleString() ?? "-"}</td>
                                            <td>{beanInfo.OthersValue?.toLocaleString() ?? "-"}</td>
                                            <td>{beanInfo.DiscountAmount?.toLocaleString() ?? "-"}</td>
                                            <td>{beanInfo.TotalPayment?.toLocaleString() ?? "-"}</td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan={6} className="text-center">
                                                Sin información
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-12">
                            <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={editaItem}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <GoodsStateEditor render={beanItem.GoodsStateName} idSelector={beanItem.IDGoodsState} onChange={(e) => { setBeanItem({ ...beanItem, "IDGoodsState": e.IDGoodsState, "GoodsStateName": e.Name }) }} returnType="Object" />

                                    </div>
                                    <div className="col-md-6">

                                        <GoodsSupportEditor render={beanItem.GoodsSupportName} idSelector={beanItem.IDGoodsSupport} onChange={(e) => { setBeanItem({ ...beanItem, "IDGoodsSupport": e.IDGoodsSupport, "GoodsSupportName": e.Name }) }} returnType="Object" />

                                    </div>
                                    <div className="col-md-6">
                                        <GoodsTypeEditor render={beanItem.GoodsTypeName} idSelector={beanItem.IDGoodsType} onChange={(e) => { setBeanItem({ ...beanItem, "IDGoodsType": e.IDGoodsType, "GoodsTypeName": e.Name }) }} returnType="Object" />

                                    </div>
                                    <div className="col-md-6">
                                        <label>Peso (Kg)</label>
                                        <input type="text" className="form-control" name='WeightKg' value={beanItem.WeightKg} onChange={(e) => { setBeanItem({ ...beanItem, "WeightKg": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>P/Real (Kg)</label>
                                        <input type="text" className="form-control" name='WeightKgReal' value={beanItem.WeightKgReal} onChange={(e) => { setBeanItem({ ...beanItem, "WeightKgReal": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Largo (cm)</label>
                                        <input type="text" className="form-control" name='LongLength' value={beanItem.LongLength} onChange={(e) => { setBeanItem({ ...beanItem, "LongLength": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Ancho (cm)</label>
                                        <input type="text" className="form-control" name='WidthLength' value={beanItem.WidthLength} onChange={(e) => { setBeanItem({ ...beanItem, "WidthLength": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Alto (cm)</label>
                                        <input type="text" className="form-control" name='HightLength' value={beanItem.HightLength} onChange={(e) => { setBeanItem({ ...beanItem, "HightLength": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Volumen</label>
                                        <input type="text" className="form-control" name='Volume' value={beanItem.Volume} onChange={(e) => { setBeanItem({ ...beanItem, "Volume": e.target.value }) }} readOnly />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Descripción Pieza</label>
                                        <textarea className="form-control" name='Description' value={beanItem.Description} onChange={(e) => { setBeanItem({ ...beanItem, "Description": e.target.value }) }} />
                                    </div>
                                </div>
                            </Modal>

                            <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteTransportGuideItem}>
                                <strong>Eliminar item {beanItem.Name}</strong>
                            </ModalConfirm>

                            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={addTransportGuideItemList}>
                                <div className="row">
                                    <TransportGuideItemNew value={itemsguide} onChange={(data) => setitemsguide(data)} />
                                </div>
                            </Modal>
                        </div>
                    </div>
                }
            </div>
        </BasicPage>
    )
}